import PropTypes from 'prop-types';
import React from 'react';
import NavButton from './navbar/container/navbutton.jsx';

import proxyFactory from './proxy_factory.jsx';
import SearchBox from './searchbox';
import Headroom from 'react-headroom';
import classnames from 'classnames';
import OfflineMenu from './offline_menu.jsx';

function Navbar(props) {
    const { showHome = true, pin = true, contentId, isSearchResults } = props;
    let { children } = props;

    if (props.showSearch) {
        if (props.children != null) {
            throw new Error(`You can't pass children and showSearch`);
        }
        children = (
            <div className="pull-right header-right">
                <OfflineMenu toolTipDirection="left" />
                <SearchBox contentId={contentId} />
            </div>
        );
    }

    let titleMarkup;
    if (props.title) {
        titleMarkup = (
            <h1 aria-hidden="true" className="contextual-title">
                {props.title}
            </h1>
        );
    }
    let home;
    if (showHome) {
        home = <NavButton />;
    }

    const tmp = classnames({
        headroom: pin,
        'headroom--pinned': pin,
    });

    return (
        <Headroom disableInlineStyles>
            <div className={tmp}>
                {isSearchResults ? (
                    <header className="navbar">
                        <div className="navbar-inner">
                            <div className="container">
                                {home}
                                {titleMarkup}
                                {children}
                            </div>
                        </div>
                    </header>
                ) : (
                    <nav className="navbar">
                        <div className="navbar-inner">
                            <div className="container">
                                {home}
                                {titleMarkup}
                                {children}
                            </div>
                        </div>
                    </nav>
                )}
            </div>
        </Headroom>
    );
}
Navbar.propTypes = {
    contentId: PropTypes.number,
    children: PropTypes.any,
    showSearch: PropTypes.bool,
    navThickBorder: PropTypes.bool,
    params: PropTypes.object,
    title: PropTypes.string,
    showHome: PropTypes.bool,
    pin: PropTypes.bool,
    isSearchResults: PropTypes.bool,
};

export default proxyFactory(Navbar);



// WEBPACK FOOTER //
// ./src/components/navbar.jsx